module.exports = __webpack_public_path__ + "img/maze_heart_c.735600e8.svg";